module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  props:
    active_country_codes: { default: null }
    country_links:        { default: null }
    zoom_state:           { default: 'world' }
    center_lat:           { default: null }
    center_lng:           { default: null }


  methods:

    loadMapPopup: ->
      @.$store.dispatch('popups/show', {
        name:                 'countries-map'
        active_country_codes: @active_country_codes
        country_links:        @country_links
        zoom_state:           @zoom_state
        center_lat:           @center_lat
        center_lng:           @center_lng
      })

    onClick: ->
      @loadMapPopup()



// WEBPACK FOOTER //
// ./assets/js/frontend/components/countries_map_container/index.coffee